import { createDefaultTyrann } from '@apis/common';
import {
  adminPatchDeliveryInstruction,
  deliveryInstruction,
  deliveryInstructionList,
  deliveryInstructionListQueryParams,
  patchDeliveryInstruction,
} from '@models/DeliveryInstruction';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const deliveryInstructionApis = createDefaultTyrann({
  '/delivery-instruction/': {
    get: {
      query: deliveryInstructionListQueryParams,
      response: {
        200: deliveryInstructionList,
        404: t.type({}),
      },
    },
  },
  '/delivery-instruction/{d2d_no}/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: deliveryInstruction,
        404: t.type({}),
      },
    },
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: patchDeliveryInstruction,
      response: {
        200: deliveryInstruction,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/delivery-instruction/{d2d_no}/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: deliveryInstruction,
        404: t.type({}),
      },
    },
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: adminPatchDeliveryInstruction,
      response: {
        200: deliveryInstruction,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
});
